import { Injectable } from '@angular/core';

@Injectable()
export class NiveauModel {

  constructor() { }
  public id_cycle:string;
  public lib_niveau:string;
}